import { cn } from '@/lib/utils';
import { Content } from '@/components/layout/Content';
import { PageHeaderProps } from './types';
import { usePageShellContext } from '../../context';

const PageHeader = (props: PageHeaderProps) => {
  const {
    children,
    className,
    contentClassName
  } = props;

  const {
    contentVariant,
    headerMode
  } = usePageShellContext();

  return (
    <header
      className={cn(
        'w-full shrink-0 pt-[env(safe-area-inset-top)] min-[769px]:pt-0',
        headerMode === 'fixed' && 'fixed inset-x-0 top-0 z-40',
        className
      )}
    >
      <Content
        className={contentClassName}
        variant={contentVariant}
      >
        {children}
      </Content>
    </header>
  );
};

export default PageHeader;